import { render, staticRenderFns } from "./perincian.vue?vue&type=template&id=31e429e2&"
import script from "./perincian.vue?vue&type=script&lang=js&"
export * from "./perincian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports